import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  listViewButton: {
    description: 'Button text to enable List View for customs declarations',
    defaultMessage: 'List View',
    id: 'kGrN/Y',
  },
  tabViewButton: {
    description: 'Button text to enable Tab View for customs declarations',
    defaultMessage: 'Tab View',
    id: 'fyEuxf',
  },
});
